<template>



    <div v-if="packageAvailability" class="add-on-panel has-shadow bg-white mb-4 position-relative"
         v-bind:class="{'h-100' : isHorizontal}">



        <span class="add-on-price" v-if="packageAvailability.availability.Amount">
            <span class="add-on-price-amount">
                &pound;{{priceFormatted(packageAvailability.availability.Amount)}}
            </span>/{{packageAvailability.content.PerText}}

        </span>
        <div class="row">

            <div class="col-xl-8"
                 v-bind:class="{'col-xl-24' : isHorizontal}">
                <div class="add-on-gallery">
                    <single-image-gallery v-bind:images="packageAvailability.content.Images"></single-image-gallery>
                </div>
            </div>
            <div class="col-xl-16 d-flex"
                 v-bind:class="{'col-xl-24' : isHorizontal}">
                <div class="row ">
                    <div class="col-xl-12 px-5 py-3 py-xl-5 position-relative"
                         v-bind:class="{'col-xl-24' : isHorizontal}">
                        <h3 class="add-on-title mb-0 mb-xl-3">{{packageAvailability.content.DisplayName}}</h3>

                        <div class="add-on-description" v-html="packageAvailability.content.LongDescription"></div>


                    </div>


                    <div class="col-xl-12 px-5 py-3 py-xl-5 pb-4 justify-content-end flex-column d-flex  "
                         v-bind:class="{'col-xl-24' : isHorizontal}">

                        <div class=" mt-5">
                            <div v-for="(leg, index) in allowedLegs" class="allowed-leg">






                                <div class="row"
                                     v-if="packageAvailability.content.Restaurant">

                                    <div class="col-24">

                                        <div v-if="doesLegHavePackage(leg, packageAvailability)">

                                            <label class="add-on-label">Room {{leg.leg}}</label>

                                            <div class="package-config">
                                                <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                    <strong>

                                                        {{formatDate(s.date)}}  &nbsp;-&nbsp;{{formatTime(s.selection)}}
                                                    </strong>
                                                    <div>
                                                        &nbsp;-&nbsp; {{s.quantity}} {{s.quantity == 1 ? 'guest' : 'guests' }}
                                                    </div>
                                                </div>

                                                <button class="package-config-reset"
                                                        v-on:click="removePackage(leg, packageAvailability)">
                                                    Reset
                                                </button>

                                            </div>

                                        </div>



                                        <button v-else class="btn btn--slate-blue btn--block btn--add"
                                                v-on:click="onAddDining(leg, packageAvailability )">
                                            <span>Book a table</span>
                                        </button>
                                    </div>

                                </div>

                                <div class="row"
                                     v-else-if="packageAvailability.content.IsSpaTreatments">


                                    <div v-if="doesLegHavePackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>

                                                    {{formatDate(s.selection.selection.StartTime)}}  &nbsp;-&nbsp;{{formatTime(s.selection.selection.StartTime)}}
                                                </strong>
                                                <div>


                                                    {{leg.guests[s.selection.guestIndex].firstName}} - {{s.selection.treatment.DisplayName}}

                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>



                                    <button v-else class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddSpa(leg, packageAvailability )">
                                        <span>Add to room {{leg.leg}}</span>
                                    </button>
                                </div>








                                <div class="row"
                                     v-else-if="packageAvailability.content.IsMudTreatment">


                                    <div v-if="doesLegHavePackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>

                                                    {{formatDate(s.selection.StartDateTime)}}  &nbsp;-&nbsp;{{formatTime(s.selection.StartDateTime)}}
                                                </strong>
                                                <div>
                                                    {{getGuests(s,leg)}}


                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>



                                    <button v-else class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddMud(leg, packageAvailability )">
                                        <span>Add to room {{leg.leg}}</span>
                                    </button>
                                </div>




                                <div class="row"
                                     v-else-if="packageAvailability.content.IsSpaGarden">


                                    <div v-if="doesLegHavePackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>

                                                    {{formatDate(s.selection.StartDateTime)}}  &nbsp;-&nbsp;{{formatTime(s.selection.StartDateTime)}}
                                                </strong>
                                                <div>
                                                    {{getGuests(s,leg)}}


                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>



                                    <button v-else class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddGarden(leg, packageAvailability )">
                                        <span>Add to room {{leg.leg}}</span>
                                    </button>
                                </div>




                                <div class="row" v-else>
                                    <div class="col-24">

                                        <label class="add-on-label">Room {{leg.Leg}}</label>
                                        <button class="btn btn--slate-blue btn--block"
                                                v-if="!doesLegHavePackage(leg,packageAvailability)"
                                                v-bind:class="getButtonClass(leg, packageAvailability)"
                                                v-on:click="addPackage(leg, packageAvailability)">

                                            Add
                                        </button>

                                        <button v-else class="btn btn--slate-blue btn--block"
                                                v-bind:class="getButtonClass(leg, packageAvailability)"
                                                v-on:click="removePackage(leg, packageAvailability)">

                                            Remove
                                        </button>




                                    </div>
                                </div>



                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

    </div>

    <account-modal v-if="modalRestaurantVisible" v-on:close="modalRestaurantVisible = false">
        <template v-slot:logo>
            <img src="/Assets/img/booking/spa_package-gold.svg" />
        </template>
        <template v-slot:body>
            <account-package-dinner-availability v-bind:activeBooking="booking"
                                                 v-bind:activePackage="activePackage"
                                                 v-bind:activeLeg="activeLeg"></account-package-dinner-availability>

        </template>
    </account-modal>




    <div class="modal-full">
        <account-modal v-if="modalSpaVisible" v-on:close="modalSpaVisible = false">
            <template v-slot:logo>
                <img src="/Assets/img/booking/spa_package-gold.svg" />
            </template>
            <template v-slot:body>
                <account-package-spa-availability
                                                   v-bind:activeBooking="booking"
                                                  v-bind:activePackage="activePackage"
                                          v-bind:activeLeg="activeLeg"></account-package-spa-availability>

            </template>

        </account-modal>
    </div>



    <div class="modal-full">
        <account-modal v-if="modalMudVisible" v-on:close="modalMudVisible = false">
            <template v-slot:logo>
                <img src="/Assets/img/booking/spa_package-gold.svg" />
            </template>
            <template v-slot:body>

                <account-package-spa-mud-availability
                                                      
                                                       v-bind:activeBooking="booking"
                                                      v-bind:activePackage="activePackage"
                                              v-bind:activeLeg="activeLeg"></account-package-spa-mud-availability>

            </template>

        </account-modal>
    </div>


    <div class="modal-full">
        <account-modal v-if="modalGardenVisible" v-on:close="modalGardenVisible = false">
            <template v-slot:logo>
                <img src="/Assets/img/booking/spa_package-gold.svg" />
            </template>
            <template v-slot:body>

                <account-package-spa-garden-availability 
                                                          v-bind:activeBooking="booking"
                                                         v-bind:activePackage="activePackage"
                                                 v-bind:activeLeg="activeLeg"></account-package-spa-garden-availability>

            </template>

        </account-modal>
    </div>








</template>

<script>

    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';
    import Spinner from '@/shared/components/Spinner.vue';
    import AccountPackageDinnerAvailability from './AccountPackageDinnerAvailability.vue';

    import AccountPackageSpaAvailability from './AccountPackageSpaAvailability.vue';
    import AccountPackageSpaMudAvailability from './AccountPackageSpaMudAvailability.vue';
    import AccountPackageSpaGardenAvailability from './AccountPackageSpaGardenAvailability.vue';

    import AccountModal from './AccountModal.vue';
    import { accountStore } from '../store/index';

    import stayapi from '@/shared/api/stay';


    export default {
        name: 'AccountPackagePanel',
        props: {
            leg: String,
            availability: Object,
            isHorizontal: Boolean,
            booking: Object
        },
        computed: {
            configuration() {
                return accountStore.getters.accountConfiguration;

            },
            price() {
                return 0;
            },
            allowedLegs() {

                let result = [];
                let booking = this.booking;
                for (let li in booking) {




                    let leg = booking[li];
                    if (leg.IsCancelled) {
                        continue;
                    }


                    let rateCode = leg.RateCode;
                    let rateGroupRate = this.configuration.RateTypes.find(item => item.PMSCode == rateCode);

                    if (rateGroupRate != undefined && rateGroupRate.AllowedAddOnPackages != null) {
                        if (rateGroupRate.AllowedAddOnPackages.includes(this.packageAvailability.availability.Code)) {
                            result.push(leg)
                        }
                    }
                }
                return result;
            }
        },
        components: {
            SingleImageGallery,
            Spinner,
            AccountPackageDinnerAvailability,
            AccountModal,
            AccountPackageSpaAvailability,
            AccountPackageSpaMudAvailability,
            AccountPackageSpaGardenAvailability
        },
        data() {
            return {
                modalRestaurantVisible: false,
                packageAvailability: null,
                flatRateSelected: false,
                activeLeg: null,

                modalSpaVisible: false,
                modalMudVisible: false,
                modalGardenVisible: false,
            
     
                activePackage: null,
            }
        },
        mounted() {

            this.packageAvailability = this.availability;

        },

        methods: {
            onAddDining(leg, pckge) {
                this.activeLeg = leg;

                this.activePackage = pckge;

                this.modalRestaurantVisible = true;
            },

            onAddSpa(leg, pckge) {
                this.activeLeg = leg;
                this.activePackage = pckge;

                this.modalSpaVisible = true;

            },

            onAddMud(leg, pckge) {
                this.activeLeg = leg;
                this.activePackage = pckge;

                this.modalMudVisible = true;

            },
            onAddGarden(leg, pckge) {
                this.activeLeg = leg;
                this.activePackage = pckge;

                this.modalGardenVisible = true;

            },





            paymentMethodDescription(value) {
                switch (value) {
                    case 0:
                        return "item"; paymentMethodDescription
                    case 1:
                        return "adult";
                    case 2:
                        return "child";
                    case 3:
                        return "person";
                    case 4:
                        return "room";
                }
                return "";
            },
            totalGuests(leg) {
                return leg.guestQuota.Adults + leg.guestQuota.Children + leg.guestQuota.Infants;
            },
            setQuantity(value) {
                this.packageAvailability.quantity = value;
            },

            addPackage(leg, item) {

                // Use sweetalert2



                this.$swal.fire({
                    text: "Would you like to add the " + item.content.DisplayName + " package?",
                    showCancelButton: true,
                    confirmButtonColor: '#a10000',
                    cancelButtonColor: '#425261',

                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    icon: 'question',
                    input: 'select',

                    inputOptions: [1, 2, 3, 4, 5, 6],
                    inputPlaceholder: 'Quantity',

                }).then((result) => {

                    if (result.isConfirmed) {

                        //value is reuslt, so we need to add 1
                        let quantity = +(result.value) + 1;
                        let payload = {
                            internalIdentifier: leg.InternalIdentifier,
                            confirmationNumber: leg.ConfirmationNumber,
                            leg: leg.Leg,
                            productCode: item.availability.Code,
                            quantity: quantity,
                            startDate: leg.DateRange.StartDate,
                            endDate: leg.DateRange.EndDate
                        };

                        stayapi.addPackage(payload, t => {
                            window.location.reload()
                        });

                    }
                });







            },
            removePackage(leg, item) {

                // Use sweetalert2
                this.$swal.fire({
                    title: 'Remove package?',
                    text: "Are you sure you want to remove the " + item.content.DisplayName + " package?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#a10000',
                    cancelButtonColor: '#425261',

                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                }).then((result) => {
                    if (result.isConfirmed) {
                        let payload = {
                            internalIdentifier: leg.InternalIdentifier,
                            confirmationNumber: leg.ConfirmationNumber,
                            leg: leg.Leg,
                            productCode: item.availability.Code
                        };
                        stayapi.removePackage(payload, t => {
                            window.location.reload()
                        });
                    }

                })




            },

            doesLegHavePackage(leg, item) {
                if (leg.Packages != undefined && leg.Packages != null) {

                    if (leg.Packages.find(p => p.Code == item.availability.Code) != null) {
                        return true;
                    }
                }
                return false;
            },
            getButtonClass(leg, item) {

                if (this.doesLegHavePackage(leg, item)) {
                    return 'btn--remove';

                }
                return "btn--add";
            },

            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            }

        },
    }
</script>

<style scoped>
    .add-on-panel {
    }


        .add-on-panel > .row {
            height: 100%;
        }

    .add-on-gallery {
        height: 344px;
    }

    .add-on-panel .spinner {
        flex-direction: row-reverse;
        height: 80%;
        border: none;
        top: 10%;
        position: relative;
        justify-content: space-between;
    }

        .add-on-panel .spinner label {
            font-size: 18px;
            margin-right: 10px;
            font-weight: 300;
        }

        .add-on-panel .spinner .selector {
            border: none;
            align-items: center;
            width: 105px;
        }

        .add-on-panel .spinner .btn-selector {
            border: solid 1px #eae5e3;
            height: 32px;
            width: 32px;
        }

    .add-on-price {
        text-align: right;
        font-weight: 300;
        width: 100%;
        display: inline-block;
        margin-bottom: 20px;
        position: absolute;
        top: 40px;
        right: 40px;
    }

    .add-on-price-m {
        position: static;
        margin-bottom: 0px;
        left: 0;
        top: 0;
        text-align: left;
    }

    .add-on-price-amount {
        font-size: 24px;
        font-weight: bold;
    }

    .add-on-title {
        font-size: 24px;
    }

    .add-on-label {
        font-size: 14px;
        font-weight: bold;
    }

    .add-on-description {
        font-size: 14px;
    }



    .flat-rate-toggle {
        background: #eae5e3;
        padding: 15px;
        font-size: 14px;
        font-weight: bold;
        min-width: 205px;
        cursor: pointer;
        width: 100%;
        line-height: 22px;
    }

        .flat-rate-toggle input[type=checkbox],
        .flat-rate-toggle span {
            line-height: 22px;
            display: inline-block;
            vertical-align: baseline;
        }

        .flat-rate-toggle input[type=checkbox] {
            height: 22px;
            width: 22px;
            margin-right: 10px;
            top: 4px;
            position: relative;
        }

    .allowed-leg {
        margin-bottom: 15px;
    }

        .allowed-leg:last-of-type {
            margin-bottom: 0;
        }

    .btn {
        margin-bottom: 0 !important;
    }
</style>